// extracted by mini-css-extract-plugin
export default {"header":"authenticationPage_header__s1enl"};